import { APIGet, APIPost } from '../services/API'


/*
args {
    page: int
}
*/
export const getGroups = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_GROUPS',
        payload: {
            ui: "loading"
        }
    });

    let url = site + '/api/v1/groups';
    if (args.source === 'pco') url = site + '/api/v1/pco/groups?pcogrouptype=' + args.pcoslug;
    if (args.source === 'ccb') url = site + '/api/v1/ccb/groups';
    if (args.source === 'churchsuite') url = site + '/api/v1/churchsuite/groups';

    let qs = [];

    if (args.page) qs.push('page=' + args.page);
    if (args.category) qs.push('category=' + args.category);
    if (args.when) qs.push('when=' + args.when);
    if (args.area) qs.push('area=' + args.area);
    if (args.search) qs.push('search=' + args.search)
    if (args.ccbcategory) qs.push('ccbcategory=' + args.ccbcategory)
    if (args.order) qs.push('order=' + args.order)

    let queryString = qs.join('&');

    url += '?' + queryString;

    // Send Request To Get Events
    APIGet(url)
        .then(res => res.json())
        .then(json => {
            dispatch({ type: 'GET_GROUPS_SUCCESS', payload: { ui: "success", groups: json } });
        })
        .catch(e => {
            dispatch({ type: 'GET_GROUPS_ERROR', payload: { ui: "error", message: e } });
        })

}

export const getFilters = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_GROUPS_FILTERS',
        payload: {
            ui: "loading"
        }
    });

    let url = site + '/api/v1/groups/filters';

    // Categories
    let qs = [];
    if (args.category) qs.push('category=' + args.category);
    let queryString = qs.join('&');
    url += '?' + queryString;

    // Send Request To Get Events
    APIGet(url)
        .then(res => res.json())
        .then(json => {
            dispatch({
                type: 'GET_GROUPS_FILTERS_SUCCESS', payload: {
                    ui: "success",
                    categories: json.categories,
                    when: json.when,
                    areas: json.areas
                }
            });
        })
        .catch(e => {
            dispatch({ type: 'GET_GROUPS_FILTERS_ERROR', payload: { ui: "error", message: e } });
        })

}

export const submitConnectForm = (args) => (dispatch, getState) => {

    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'POSTING_GROUPS_FORM',
        payload: {
            ui: "loading"
        }
    });

    APIPost(site + '/api/v1/groups/email', args)
        .then(res => res.json())
        .then(json => dispatch({ type: 'POSTING_GROUPS_FORMS_SUCCESS', payload: { ui: "success" } }))
        .catch(e => dispatch({ type: 'POSTING_GROUPS_FORM_ERROR', payload: { ui: "error", message: e } }))

}
